import { APP_PREFIX_PATH } from 'configs/AppConfig'
import { isBranchUserType, isEmployerUserType } from 'constants/AuthConstant'

export const AGREEMENT_PROFILE_PATH = `${APP_PREFIX_PATH}/dashboards/profile/agreement`

const ACCEPTED_STATUSES = new Set([
  'accepted',
  'signed',
  'completed',
  'approved',
])

export const getEmployerAgreement = (user) => {
  if (!user || typeof user !== 'object') return null

  const employer = user.employer
  if (employer && typeof employer === 'object' && !Array.isArray(employer)) {
    const nested = employer.agreement
    if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
      return nested
    }
  }

  const direct = user.agreement
  if (direct && typeof direct === 'object' && !Array.isArray(direct)) {
    return direct
  }

  return null
}

/** Primary truth: agreementStatus only (not agreementUrl). */
export const isAgreementAccepted = (agreement) => {
  if (!agreement) return false
  const status = String(agreement.agreementStatus || '')
    .trim()
    .toLowerCase()
  return ACCEPTED_STATUSES.has(status)
}

export const isUserAgreementAccepted = (user) =>
  isAgreementAccepted(getEmployerAgreement(user))

/** Employer account Active (user.status). Branch / missing user → not applicable here. */
export const isEmployerAccountActive = (user) => {
  if (!user || typeof user !== 'object') return false
  const status = String(user.status || user.employer?.status || '')
    .trim()
    .toLowerCase()
  return status === 'active'
}

/** Employer only. Branch skip. Not accepted → must sign. */
export const needsEmployerAgreement = (user, userType) => {
  const type = userType || user?.userType || user?.type
  if (isBranchUserType(type)) return false
  if (!isEmployerUserType(type)) return false
  return !isUserAgreementAccepted(user)
}

/** Employer not Active → block unlocked app (Branch skipped). */
export const needsEmployerActiveAccount = (user, userType) => {
  const type = userType || user?.userType || user?.type
  if (!isEmployerUserType(type)) return false
  return !isEmployerAccountActive(user)
}

export const isAgreementRoute = (pathname = '') =>
  pathname.includes('/dashboards/profile/agreement')

/** Merge GET /employer/profile into auth user (agreement + status stay fresh). */
export const mergeEmployerApiProfile = (currentUser = {}, apiProfile = {}) => {
  if (!apiProfile || typeof apiProfile !== 'object') {
    return currentUser
  }

  const nextEmployer = {
    ...(currentUser?.employer && typeof currentUser.employer === 'object'
      ? currentUser.employer
      : {}),
    ...(apiProfile.employer && typeof apiProfile.employer === 'object'
      ? apiProfile.employer
      : {}),
  }

  const nextAgreement =
    (apiProfile.employer &&
      typeof apiProfile.employer === 'object' &&
      apiProfile.employer.agreement) ||
    apiProfile.agreement ||
    nextEmployer.agreement ||
    currentUser?.employer?.agreement

  if (nextAgreement && typeof nextAgreement === 'object') {
    nextEmployer.agreement = nextAgreement
  }

  return {
    ...currentUser,
    ...apiProfile,
    status: apiProfile.status ?? currentUser?.status,
    employer: nextEmployer,
  }
}

export const unwrapEmployerProfileResponse = (response) => {
  if (!response || typeof response !== 'object') return null
  const data = response.data
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    if (data.employer || data.status || data._id || data.agreement) {
      return data
    }
    if (data.data && typeof data.data === 'object' && !Array.isArray(data.data)) {
      return data.data
    }
  }
  if (response.employer || response.status || response._id) {
    return response
  }
  return null
}
